module.exports = __webpack_public_path__ + "static/livestorm-thumbnail2-46d914ad1b03400b39cdf53237eee9a7.png";